import * as React from 'react';
import dayjs, { Dayjs } from 'dayjs';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import moment from 'moment';

export default function SecondsTimePicker(props: any) {
  const { node, data, change } = props;
  // const [value, setValue] = React.useState<Dayjs | null>(dayjs('2022-04-07'));



  const secondsToHMS = (seconds: number) => { const hours = Math.floor(seconds / 3600); const minutes = Math.floor((seconds % 3600) / 60); const remainingSeconds = seconds % 60; return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`; };
  const getCurrentDate = () => { const currentDate = new Date(); const year = currentDate.getFullYear(); const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); const day = currentDate.getDate().toString().padStart(2, '0'); return `${year}-${month}-${day}`; };

  const convertToMuiValue = (seconds: number) => {
    console.log("seconds", seconds)
    const timeString = secondsToHMS(seconds);
    const currentDate = getCurrentDate()

    const dateTimeString = `${currentDate}T${timeString}`;


    return dateTimeString.trim()

  }



  function mmssToSeconds(time: string) {
    // Split the time string into minutes and seconds
    const parts = time.split(':');

    // Extract minutes and seconds
    const minutes = parseInt(parts[0]);
    const seconds = parseInt(parts[1]);

    // Convert minutes to seconds and add the seconds
    const totalSeconds = minutes * 60 + seconds;

    return totalSeconds;
  }




  const handleChange = (dateTimeString: any) => {
    const value = moment(dateTimeString?.$d ? dateTimeString?.$d : dateTimeString).format("mm:ss")
    let copyData = [...data]
    copyData?.map((child: any) => {
      if (node?.name === child?.name) {
        node.value = mmssToSeconds(value)
      }
      return node

    })

    change([...copyData])
  }







  return (
    <div className='relative p-2'>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Stack spacing={3}>
          <TimePicker
            ampm={false}
            openTo="minutes"
            views={['minutes', 'seconds']}
            inputFormat="mm:ss"
            mask="__:__"
            label={node?.title}
            onError={(e) => console.log("error", e)}
            value={dayjs(convertToMuiValue(typeof (node?.value) === "number" ? node?.value : 1))}
            onChange={(newValue) => {
              handleChange(newValue)
            }}
            renderInput={(params) => <TextField {...params} />}
          />
        </Stack>
      </LocalizationProvider>
      {node?.helperText && <div className='text-sm py-1 p-2 rounded-md mx-2 absolute top-full right-0  text-[white] bg-primary max-w-full'>
        {node?.helperText}
      </div>
      }

    </div>
  );
}